import React from 'react';
import {withErrorBoundary} from '../components/common/error-boundary/ErrorBoundary';
import LazyLoad from '../components/common/lazy-load/LazyLoad';
import {placeholder} from '../components/common/loading';
import MvtTest from '../components/common/mvt/MvtTest/MvtTest';
import {AsyncTripboard} from '../components/common/tripboard/AsyncTripboard';

export const fullExposures = (tests) =>
    tests.map((test) => (
        <MvtTest key={`report-${test}`} test={test} reportOnMount />
    ));

export const lazy = (children) =>
    withErrorBoundary(
        <LazyLoad placeholder={placeholder(children)}>{children}</LazyLoad>
    );

export {withErrorBoundary};

export const withTripboards = (children) =>
    withErrorBoundary(<AsyncTripboard>{children}</AsyncTripboard>);
export const withTripboardsLazy = (children) =>
    lazy(<AsyncTripboard>{children}</AsyncTripboard>);
